import vueI18n from '@/i18n/locale'
import { Notification } from '@didi-pebble/pebble-design-vue'
import { useStore } from '@/store'
let flag = false
export const reloadFlagKey = 'gtr_reload_key'
export function showUpdateInfo(message, isReload = false) {
  const store = useStore()
  console.log('log => showUpdateInfo', message)
  if (flag) {
    return
  }
  flag = true
  if (isReload) {
    // 刷新的标识，防止缓存逻辑。拦截走缓存的逻辑。
    sessionStorage.setItem(reloadFlagKey, true)
    store.switch()
    window.location.reload()
    // reload()
    return
  }
  sessionStorage.removeItem(reloadFlagKey)

  Notification({
    title: vueI18n.t('Gattaran_mgt_Tips_NpAN'), // 提示
    message: vueI18n.t('Gattaran_alert_zVGm_gOUV'), // 发现新版本数据，刷新后可获取最新内容
    customBtn: [
      {
        value: vueI18n.t('FoodB_statistics_Refresh_qDDP'), // 刷新
        styleObject: {
          marginLeft: '10px',
        },
        actions: close => {
          // 清空缓存
          reload()
        },
      },
    ],
    duration: 0,
    type: 'warning',
  })
  // 节流
  setTimeout(() => {
    flag = false
  }, 5000)
}
function reload() {
  const store = useStore()
  store.switch()
  setTimeout(() => {
    flag = false
    window.location.reload()
  }, 500)
}
// function logger(message) {
//   // 彩色logger
//   console.log(
//     '%c log => %c %s',
//     'color: #000; background: #fff; padding: 2px 4px; border-radius: 4px;',
//     'color: #000; background: #fff; padding: 2px 4px; border-radius: 4px;',
//     message,
//   )
// }
